import type { CreateCategoryWithRule } from '@mynt/backoffice-api-spec/spendcontrols'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { createCategoryWithRule } from 'SpendControl/endpoints'

export const useCreateCategoryWithRule = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateCategoryWithRule) => createCategoryWithRule(params),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
    },
  })
}
